import React from 'react'

interface IconProps {
  className?: string
}

const DistributeSpacingVertical = ({ className }: IconProps) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
  >
    <path
      d="M19 1H1M19 19H1M3 10C3 9.06812 3 8.60218 3.15224 8.23463C3.35523 7.74458 3.74458 7.35523 4.23463 7.15224C4.60218 7 5.06812 7 6 7L14 7C14.9319 7 15.3978 7 15.7654 7.15224C16.2554 7.35523 16.6448 7.74458 16.8478 8.23463C17 8.60218 17 9.06812 17 10C17 10.9319 17 11.3978 16.8478 11.7654C16.6448 12.2554 16.2554 12.6448 15.7654 12.8478C15.3978 13 14.9319 13 14 13L6 13C5.06812 13 4.60218 13 4.23463 12.8478C3.74458 12.6448 3.35523 12.2554 3.15224 11.7654C3 11.3978 3 10.9319 3 10Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default DistributeSpacingVertical
